export var IdLandingPageMessages;
(function (IdLandingPageMessages) {
    IdLandingPageMessages["GetAutologinData"] = "ggsGetAutologinData";
    IdLandingPageMessages["Load"] = "ggsOnLoad";
    IdLandingPageMessages["LoadComplete"] = "ggsOnLoadComplete";
    IdLandingPageMessages["LoginComplete"] = "ggsOnLoginComplete";
    IdLandingPageMessages["Logout"] = "ggsOnLogout";
    IdLandingPageMessages["Register"] = "ggsOnRegisterComplete";
    IdLandingPageMessages["RemoveAutologinData"] = "ggsRemoveAutologinData";
    IdLandingPageMessages["GGSTrackEvent"] = "ggsTrackEvent";
    IdLandingPageMessages["ggsGetReferrer"] = "ggsGetReferrer";
    IdLandingPageMessages["ggsRedirectToLandingPage"] = "ggsRedirectToLandingPage";
})(IdLandingPageMessages || (IdLandingPageMessages = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdLandingPageMessages.ts
// module id = 1683
// module chunks = 3